import styles from './GeoInputAddonSection.css';

export const GeoInputAddonSection: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
